import { motion } from "motion/react";
import { memo } from "react";
import svgPaths from "../imports/svg-776og5bma1";

// Calculate drift positions for each segment (outward from center)
const segments = [
  {
    path: svgPaths.p185a8e00,
    fill: "#F47421",
    id: "Vector",
    driftX: 0,
    driftY: -45,
  },
  {
    path: svgPaths.p1d614000,
    fill: "#F47421",
    id: "Vector_2",
    driftX: 45,
    driftY: 0,
  },
  {
    path: svgPaths.pebb2d80,
    fill: "#EF4839",
    id: "Vector_3",
    driftX: 50,
    driftY: 50,
  },
  {
    path: svgPaths.p68df900,
    fill: "#EF4839",
    id: "Vector_4",
    driftX: -45,
    driftY: 0,
  },
  {
    path: svgPaths.p10c6be80,
    fill: "#F47421",
    id: "Vector_5",
    driftX: 0,
    driftY: 50,
  },
];

function LogoAnimation() {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: '100%'
    }}>
      <div style={{
        position: 'relative',
        height: '150px',
        width: '120px'
      }}>
        <svg
          style={{
            position: 'absolute',
            inset: 0,
            display: 'block',
            width: '100%',
            height: '100%'
          }}
          fill="none"
          preserveAspectRatio="xMidYMid meet"
          viewBox="0 0 110 140"
        >
          <g id="Frame 10">
            {segments.map((segment) => (
              <motion.path
                key={segment.id}
                d={segment.path}
                fill={segment.fill}
                id={segment.id}
                initial={{
                  x: 0,
                  y: 0,
                  rotate: 0,
                  opacity: 1,
                }}
                animate={{
                  x: [0, segment.driftX, segment.driftX, 0, 0],
                  y: [0, segment.driftY, segment.driftY, 0, 0],
                  rotate: [0, 180, 180, 0, 0],
                  opacity: [1, 0.3, 0.3, 1, 1],
                }}
                transition={{
                  duration: 4.5,
                  times: [0, 0.4, 0.5, 0.9, 1],
                  ease: "easeInOut",
                  repeat: Infinity,
                  repeatType: "loop",
                }}
              />
            ))}
          </g>
        </svg>
      </div>
    </div>
  );
}

export default memo(LogoAnimation);
